/**
 * Service: userPreferences
 */
angular.module('acme.common.service.userPreferences', [
  'acme.common.service.helpers'
])
.service('UserPreferencesService', ['$rootScope', 'HelpersService', function($rootScope, HelpersService) {

    return {

      dateFormats: {},
      settings: {
        dateFormat: ['EEEE, MMMM d, yyyy', 'MMM. d, yyyy', 'MM-dd-yyyy', 'MM/dd/yyyy', 'dd-MM-yy', 'MM/dd/yy', 'dd-MM-yyyy', 'dd/MM/yyyy', 'yyyy-MM-dd', 'yyyy MMMM d', 'yyyy-MM-dd', 'yyyy-MMM-dd', 'M/d/yy'],
        hourFormat: ['h:mm a', 'HH:mm'],
        startDayOfWeek: ['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY', 'SUNDAY']
      },
      weekMap: {
        'SUNDAY': 0,
        'MONDAY': 1,
        'TUESDAY': 2,
        'WEDNESDAY': 3,
        'THURSDAY': 4,
        'FRIDAY': 5,
        'SATURDAY': 6
      },
      adminSettings: {},
      userSettings: {},
      preferences: false,
      
      init: function () {
        return true;
      },
      
      getDateFormat: function (type, format) {
        var r;
        if(format && this.hasPreferences(format)) {
          r = this.dateFormats[format];
        } else {
          r = HelpersService.dateFormats[type];
        }
        return r;
      },

      getDateTimeFormat: function(type) {
        var r;
        if(this.hasPreferences('dateFormat') && this.hasPreferences('hourFormat')) {
          r = this.dateFormats['dateFormat'] + ' \'at\' ' + this.dateFormats['hourFormat'];
        } else {
          r = HelpersService.dateFormats[type];
        }
        return r;
      },
      
      hasPreferences: function (format) {
        var r = false;
        if (!format) {
          r = this.preferences;
        } else {
          r = (this.dateFormats[format]) ? true : false;
        }
        return r;
      },
      
      process: function(admin, user) {
        var key,
         r = { hourFormat: '', dateFormat:'', startDayOfWeek: '', accessibilityEnabled: false};
         
         this.adminSettings = admin || this.adminSettings;
         this.userSettings = user || this.userSettings;
         
        for(key in r) {
          if(r.hasOwnProperty(key)) {
            r[key] = (this.userSettings[key]) ? this.userSettings[key] : this.adminSettings[key];
          }
        }
        this.setPreferences(r);
        this.setFormat(r);
     },
      
      getStartDayOfWeek: function () {
        var r = this.weekMap['SUNDAY'];

        if(this.dateFormats.startDayOfWeek) {
          r = this.weekMap[this.dateFormats.startDayOfWeek];
        }
        return r;
      },

      getStartDayOfWeekString: function () {
        return this.dateFormats.startDayOfWeek || this.settings.startDayOfWeek[6];
      },

      getHourFormat: function() {
        var r = this.settings.hourFormat[0];

        if (this.dateFormats.hourFormat) {
          r = this.dateFormats.hourFormat;
        }

        return r;
      },

      setPreferences: function(prefs) {
        this.preferences = prefs;
      },

      getPreferences: function() {
        return this.preferences;
      },
      
      setFormat: function (user) {
        this.dateFormats.startDayOfWeek = user.startDayOfWeek || this.settings.startDayOfWeek[6];
        this.dateFormats.dateFormat = user.dateFormat || this.getDateFormat('defaultUserPreferenceFormat');
        this.dateFormats.hourFormat = user.hourFormat || this.getHourFormat();
        $rootScope.$broadcast('UserPreferencesService:onDateFormatLoad');
      }
      
    };

}]);